<template>
    <b-modal
        v-model="showModal"
        :id="'attach-by-name'"
        ref="'attach-by-name'"
        :title="$t('school.link_users')"
        size="lg"
        :ok-title="$t('common.close')"
        ok-only
        modal-class="apprentice-default-modal">
        <b-tabs>
            <b-tab
                :title="$t('school.problems')"
                active>
                <div class="row">
                    <div class="col-md-4">
                        <div
                            class="card"
                            style="padding: 5px">
                            <div class="card-title text-center">
                                {{ $t('school.unlinked_users') }}
                            </div>

                            <div class="card-body">
                                <ul>
                                    <li
                                        class="clickable-item"
                                        v-for="user of multiple">
                                        <div class="col-md-10">
                                            <b-button @click="selectedUser(user)">{{ user.name }} </b-button>

                                            <div
                                                v-if="user.attached === 1"
                                                style="display: inline-block">
                                                <div
                                                    v-for="match of user.matches"
                                                    style="display: inline-block">
                                                    <div
                                                        v-if="match.selected === 1"
                                                        style="display: inline-block">
                                                        => {{ match.email }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-md-4"
                        v-if="selected">
                        <div
                            class="card"
                            style="padding: 5px">
                            <div class="card-title text-center">
                                {{ $t('school.unlinked_existing_users') }}
                            </div>

                            <div class="card-body">
                                <ul>
                                    <li
                                        v-for="selected of selected.matches"
                                        style="margin-bottom: 10px">
                                        <b-button @click="attachUser(selected)">
                                            {{ selected.name }}
                                            <br /><br />
                                            {{ selected.email }}
                                        </b-button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <b-button
                    variant="primary"
                    @click="attachProblemUser">
                    {{ $t('school.process') }}
                </b-button>
            </b-tab>
            <b-tab :title="$t('school.suggestions')">
                <design-2021-apprentice-data-table
                    :fields="fields"
                    :items="single">
                    <template v-slot:cell(actions)="data">
                        <b-form-checkbox
                            :checked="!!data.item.checked"
                            @change="updateChecked(data.item)">
                        </b-form-checkbox>
                    </template>
                </design-2021-apprentice-data-table>

                <b-button
                    variant="primary"
                    @click="attachNonProblematicSelectedUsers">
                    {{ $t('school.process') }}
                </b-button>
            </b-tab>
        </b-tabs>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-school-las-attach-by-name-modal',
    props: ['uncheckedStudentsIn', 'uncheckedTeachersIn', 'uncheckedUserStudentsIn', 'uncheckedUserTeachersIn'],
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: this.$t('school.unlinked_users'),
                },
                {
                    key: 'suggestion_name',
                    label: 'Suggestie',
                },
                {
                    key: 'actions',
                },
            ],
            showModal: false,
            matches: [],
            single: [],
            multiple: [],
            selected: null,
            type: 'student',
        };
    },
    methods: {
        updateChecked(item) {
            if (item.checked === 1) {
                for (const user of this.single) {
                    if (item.id === user.id) {
                        user.checked = 0;
                    }
                }
            } else {
                for (const user of this.single) {
                    if (item.id === user.id) {
                        user.checked = 1;
                    }
                }
            }
        },
        show(type) {
            this.matches = [];
            this.single = [];
            this.multiple = [];
            this.selected = null;
            this.type = type;
            this.showModal = true;

            if (type === 'student') {
                for (const lasUser of this.uncheckedStudentsIn) {
                    let data = {
                        name: lasUser.full_name,
                        id: lasUser.id,
                        matches: [],
                        checked: 1,
                        attached: 0,
                    };

                    for (const user of this.uncheckedUserStudentsIn) {
                        if (
                            lasUser.first_name.toLowerCase() === user.name.toLowerCase() &&
                            lasUser.last_name.toLowerCase() === user.surname.toLowerCase()
                        ) {
                            let match = {
                                name: user.full_name,
                                id: user.id,
                                email: user.email,
                                selected: 0,
                            };

                            data.matches.push(match);
                        }
                    }

                    this.matches.push(data);
                }

                for (const match of this.matches) {
                    if (match.matches.length === 1) {
                        let data = {
                            name: match.name,
                            id: match.id,
                            checked: match.checked,
                            suggestion_name: match.matches[0].name,
                            user_id: match.matches[0].id,
                        };

                        this.single.push(data);
                    } else if (match.matches.length > 1) {
                        this.multiple.push(match);
                    }
                }
            } else {
                for (const lasUser of this.uncheckedTeachersIn) {
                    let data = {
                        name: lasUser.full_name,
                        id: lasUser.id,
                        matches: [],
                        checked: 1,
                        attached: 0,
                    };

                    for (const user of this.uncheckedUserTeachersIn) {
                        if (
                            lasUser.first_name.toLowerCase() === user.name.toLowerCase() &&
                            lasUser.last_name.toLowerCase() === user.surname.toLowerCase()
                        ) {
                            let match = {
                                name: user.full_name,
                                id: user.id,
                                email: user.email,
                                selected: 0,
                            };

                            data.matches.push(match);
                        }
                    }

                    this.matches.push(data);
                }

                for (const match of this.matches) {
                    if (match.matches.length === 1) {
                        let data = {
                            name: match.name,
                            id: match.id,
                            checked: match.checked,
                            suggestion_name: match.matches[0].name,
                            user_id: match.matches[0].id,
                        };

                        this.single.push(data);
                    } else if (match.matches.length > 1) {
                        this.multiple.push(match);
                    }
                }
            }
        },
        selectedUser(user) {
            this.selected = user;
        },
        attachUser(selected) {
            for (const single of this.multiple) {
                for (const match of single.matches) {
                    if (match.name === selected.name) {
                        if (match.selected === 1) {
                            match.selected = 0;
                        }
                    }

                    selected.selected = 1;

                    if (match.id === selected.id) {
                        single.attached = 1;
                    }
                }
            }
        },
        attachNonProblematicSelectedUsers() {
            if (this.type === 'student') {
                let toDatabase = [];

                for (const user of this.single) {
                    if (user.checked === 1) {
                        let data = {
                            user_id: user.user_id,
                            las_user_id: user.id,
                        };

                        toDatabase.push(data);
                    }
                }

                this.alert.saving();

                this.axios.post(this.routes.lasAssignByNameStudent(), toDatabase).then(
                    (response) => {
                        this.alert.success();

                        for (const attached of toDatabase) {
                            this.single = this.single.filter((user) => user.id !== attached.las_user_id);
                        }

                        this.$emit('update-students', toDatabase);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                let toDatabase = [];

                for (const user of this.single) {
                    if (user.checked === 1) {
                        let data = {
                            user_id: user.user_id,
                            las_user_id: user.id,
                        };

                        toDatabase.push(data);
                    }
                }

                this.alert.saving();

                this.axios.post(this.routes.lasAssignByNameEmployee(), toDatabase).then(
                    (response) => {
                        this.alert.success();

                        for (const attached of toDatabase) {
                            this.single = this.single.filter((user) => user.id !== attached.las_user_id);
                        }

                        this.$emit('update-teachers', toDatabase);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
        attachProblemUser() {
            if (this.type === 'student') {
                let toDatabase = [];

                for (const single of this.multiple) {
                    if (single.attached === 1) {
                        for (const match of single.matches) {
                            if (match.selected === 1) {
                                let data = {
                                    user_id: match.id,
                                    las_user_id: single.id,
                                };

                                toDatabase.push(data);
                            }
                        }
                    }
                }

                this.alert.saving();

                this.axios.post(this.routes.lasAssignByNameStudent(), toDatabase).then(
                    (response) => {
                        this.alert.success();

                        for (const attached of toDatabase) {
                            this.multiple = this.multiple.filter((single) => single.id !== attached.las_user_id);
                        }

                        this.$emit('update-students', toDatabase);
                        this.selected = null;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                let toDatabase = [];

                for (const single of this.multiple) {
                    if (single.attached === 1) {
                        for (const match of single.matches) {
                            if (match.selected === 1) {
                                let data = {
                                    user_id: match.id,
                                    las_user_id: single.id,
                                };

                                toDatabase.push(data);
                            }
                        }
                    }
                }

                this.alert.saving();

                this.axios.post(this.routes.lasAssignByNameEmployee(), toDatabase).then(
                    (response) => {
                        this.alert.success();

                        for (const attached of toDatabase) {
                            this.multiple = this.multiple.filter((single) => single.id !== attached.las_user_id);
                        }

                        this.$emit('update-teachers', toDatabase);
                        this.selected = null;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
    },
};
</script>

<style scoped></style>
